import { Spinner } from '@consigli/facade';
import {
  useProjectId,
  useServiceName,
  useBuildingPackageId,
  useGetBuildingPackageResultsQuery,
} from '@consigli/hooks';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';

import { Route } from '@/routes';

// This component is used to navigate to the correct building package page when switching packages
// If the building package has results, it will navigate to the results page
// If not, it will navigate to the input page
export const BuildingPackageNavigationWrapper = () => {
  const projectId = useProjectId();
  const buildingPackageId = useBuildingPackageId();
  const serviceName = useServiceName();
  const navigate = useNavigate();

  const { data: buildingPackageResults } = useGetBuildingPackageResultsQuery({
    projectId,
    buildingPackageId,
    page: 'all',
  });

  const hasResults = useMemo(() => {
    return buildingPackageResults ? buildingPackageResults.results.length > 0 : undefined;
  }, [buildingPackageResults]);

  const navRoute = useMemo(() => {
    return `/${Route.PROJECTS}/${projectId}/${Route.SERVICES}/${serviceName}/${Route.PACKAGES}/${buildingPackageId}/${hasResults ? Route.RESULTS : Route.INPUT}`;
  }, [projectId, serviceName, buildingPackageId, hasResults]);

  useEffect(() => {
    if (hasResults !== undefined) {
      navigate(navRoute, { replace: true });
    }
  }, [hasResults, navRoute, navigate]);

  return <Spinner size="large" />;
};
